module.exports = __webpack_public_path__ + "img/prev.0017de42.svg";